function HeroText() {
  return (
    <div>
      <div className="eyebrow">
        <span>frontend developer</span>
        <span className="sep">/</span>
        <span>toronto, on</span>
      </div>
      <h1>
        Interfaces built like
        <br />
        <span>engineering, not guesswork.</span>
      </h1>
      <p className="sub">
        React and TypeScript developer focused on precise, tested,
        production-ready frontend work — with a systems-thinking edge from
        time spent in CRM consulting.
      </p>
      <div className="cta-row">
        <a className="btn amber" href="#work">
          View work
        </a>
        <a className="btn ghost" href="#contact">
          Get in touch
        </a>
      </div>
    </div>
  );
}

export default HeroText;
